import Vue from 'vue';

const TicketClientLogged = {
  install(): void {
    Vue.prototype.ticketClientLogged = (type: string, clientId: string): string => {
      let output: string;
      switch (type) {
        case 'Unregistered':
          output = 'Not Logged';
          break;
        case 'Client':
          output = clientId === '0' ? 'Not Logged' : 'Logged In';
          break;
        case 'Admin':
          output = clientId === '0' ? 'Not Logged' : 'Logged In';
          break;
        case 'Email':
          output = 'Not Logged';
          break;
        default:
          output = 'Not Logged';
          break;
      }

      return output;
    };
  },
};

export default TicketClientLogged;


//   Logged Logic:
//  'Unregistered + ClientId != 0': 'Not Logged In  | Client'
//  'Unregistered + ClientId  = 0': 'Not Logged In  | Not a client',
//  'Client + clientId != 0'      : 'Logged in      | Client'
//  'Admin +  clientId != 0'      : 'Logged in      | Admin'
//  'Email +  clientId != 0'      : 'Not Logged In  | Client'
//  'Email +  clientId  = 0'      : 'Not Logged In  | Not a client'
